
enum PPVFont {
    Bold = 'PPV-Bold',
    Regular = 'PPV-Regular',
    Medium = 'PPV-Medium',
    SemiBold = 'PPV-SemiBold'
}

export const textStyles = {
    h1: {
        fontSize: '28px',
        fontFamily: PPVFont.Bold,
        fontWeight: 700,
        lineHeight: '40px',
    },
    h2: {
        fontSize: '24px',
        fontFamily: PPVFont.Bold,
        fontWeight: 700,
        lineHeight: '36px',
    },
    h3: {
        fontSize: '20px',
        fontFamily: PPVFont.Bold,
        fontWeight: 700,
        lineHeight: '28px',
    },
    h4: {
        fontSize: '16px',
        fontFamily: PPVFont.Bold,
        fontWeight: 700,
        lineHeight: '24px',
    },
    h5: {
        fontSize: '14px',
        fontFamily: PPVFont.Bold,
        fontWeight: 700,
        lineHeight: '20px',
    },
    h6: {
        fontSize: '12px',
        fontFamily: PPVFont.Bold,
        fontWeight: 700,
        lineHeight: '16px',
    },
    subtitle1: {
        fontSize: '16px',
        fontFamily: PPVFont.SemiBold,
        fontWeight: 600,
        lineHeight: '24px',
    },
    subtitle2: {
        fontSize: '14px',
        fontFamily: PPVFont.SemiBold,
        fontWeight: 600,
        lineHeight: '20px',
    },
    subtitle3: {
        fontSize: '12px',
        fontFamily: PPVFont.SemiBold,
        fontWeight: 600,
        lineHeight: '16px',
    },
    body1: {
        fontSize: '16px',
        fontFamily: PPVFont.Medium,
        fontWeight: 500,
        lineHeight: '24px',
    },
    body2: {
        fontSize: '14px',
        fontFamily: PPVFont.Medium,
        fontWeight: 500,
        lineHeight: '20px',
    },
    body3: {
        fontSize: '12px',
        fontFamily: PPVFont.Medium,
        fontWeight: 500,
        lineHeight: '16px',
    },
    button1: {
        fontSize: '16px',
        fontFamily: PPVFont.Bold,
        fontWeight: 700,
        lineHeight: '24px',
    },
    button2: {
        fontSize: '14px',
        fontFamily: PPVFont.Bold,
        fontWeight: 700,
        lineHeight: '20px',
    }
};